import { useDispatch, useSelector } from 'react-redux';
import { removeFlight } from '../redux/flight/actions';
import Flight from './Flight';

export default function FlightContainer() {
    const dispatch = useDispatch();
    const flights = useSelector((state) => state);

    const flightDeleteHandler = (flightId) => {
        dispatch(removeFlight(flightId));
    }

    return (
        <div className="table-container">
            <table className="booking-table">
                <thead className="bg-gray-100/50">
                    <tr className="text-black text-left">
                        <th>Destination From</th>
                        <th>Destination To</th>
                        <th className="text-center">Journey Date</th>
                        <th className="text-center">Guests</th>
                        <th className="text-center">Class</th>
                        <th className="text-center">Delete</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-300/20" id="lws-previewBooked">
                    { flights.map(f => 
                        <Flight 
                            key={f.id} 
                            flightData={f} 
                            deleteHandler={flightDeleteHandler} 
                        />) 
                    }
                </tbody>
            </table>
        </div>
    );
}